import React from 'react';
import { reduxForm, Field } from 'redux-form';

import InputField from '../../../shared/form-elements/input';
import CheckboxField from '../../../shared/form-elements/checkbox';

const Form = ({intl, updateConversionFromCheckbox }) => (
	<form className="margin-0-10 flex-center">
		<div className="conversions-filter__element">
			<Field
				name="conversionsFrom"
				placeholder={intl('Leads from')}
				showLabel={false}
				component={InputField} />
		</div>
		<div className="conversions-filter__element margin-0-10">
			<Field
				name="is_from_cpa"
				placeholder={intl('Guarant approve / compensations')}
				showLabel={false}
				onChange={updateConversionFromCheckbox.bind(null, 'is_from_cpa')}
				component={CheckboxField} />
		</div>
		<div className="conversions-filter__element">
			<Field
				name="is_from_real_crm"
				placeholder={intl('Final approve')}
				showLabel={false}
				onChange={updateConversionFromCheckbox.bind(null, 'is_from_real_crm')}
				component={CheckboxField} />
		</div>
		<div className="conversions-filter__element margin-0-10">
			<Field
				name="is_hidden_profit"
				placeholder={intl('Hide Profit')}
				showLabel={false}
				component={CheckboxField} />
		</div>
	</form>
);

export default reduxForm({
	form: 'conversionsFromTopCountriesForm'
})(Form);




// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-countries/components/form/main.js